// removed by extract-text-webpack-plugin
module.exports = {"table-responsive":"table-responsive"};


//////////////////
// WEBPACK FOOTER
// ./src/components/forms/EntityDetailsForm/EntityDetails.scss
// module id = 4345
// module chunks = 1